<template>
  <div>
    <loading-indicator v-show="isLoading" 
                       :width="width / 4" 
                       :height="width / 4">
    </loading-indicator>
    <pdf :src="pdfSrc" 
         :style="{ 'width': width + 'px' }"
         @loaded="isLoading = false">
    </pdf>
  </div>
</template>

<script>
  import pdf from 'vue-pdf';
  export default {
    components: {
        pdf
    },

    props: {
      pdfSrc: { type: String, required: true },
      width: { type: Number, required: false, default: 150 }
    },

    data() {
      return {
        isLoading: true
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>